import { AxisConfig } from "@tether-web-portal/components/charts/types";
import { Group } from "@visx/group";
import { CSSProperties, ReactNode } from "react";

export const ColumnAxisBottomLabel = ({
  backgroundHeight,
  labelStyle,
  xMax,
  children,
  axisHeightConfig,
}: {
  backgroundHeight: number;
  xMax: number;
  children: ReactNode;
  axisHeightConfig: AxisConfig;
  labelStyle: CSSProperties;
}) => {
  return (
    <Group top={backgroundHeight}>
      <foreignObject x={0} y={axisHeightConfig.gap} height={axisHeightConfig.title} width={xMax}>
        <div
          style={{
            width: "100%",
            height: "100%",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            alignContent: "center",
            textAlign: "center",
            ...labelStyle,
          }}
        >
          {children}
        </div>
      </foreignObject>
    </Group>
  );
};
